<fe-header style="z-index: 1000"></fe-header>
<main class="mb-26 mb-sm-20">
    <figure
        class="banner-msi banner-msi__mobile d-flex d-md-none justify-content-center"
    >
        <img
            alt="msi banner"
            [src]="'images/img-msi-bbva-amex-alamo.png' | cdn"
            class="banner_msi"
        />
    </figure>
    <fe-progress-bar
        *ngIf="!breakpoint.isMobile()"
        [status]="'vehicle'"
        class="d-none d-md-block"
        #progressBarDesktop
    ></fe-progress-bar>
    <fe-progress-bar-mobile
        *ngIf="breakpoint.isMobile()"
        [statusProgress]="'vehicle'"
        class="d-block d-md-none"
    ></fe-progress-bar-mobile>
    <fe-filters
        [isSidebarVisible]="isSidebarVisible"
        [international]="international"
        (toggleSidebar)="toggleSidebar()"
        (sortChange)="onSortChange($event)"
        class="mobile"
        *ngIf="isMobile"
    ></fe-filters>
    <section
        [style.marginTop.px]="progressBarDesktop?.martinTopContainer"
        class="container-fluid main"
    >
        <fe-vehicle-list
            [vehicles]="vehicles"
            [discountOffice]="discountOffice"
            [international]="international"
            [rateWeekly]="rateWeekly"
            [currency]="currency"
            [discounts]="discounts"
            [rentalDays]="rentalDays"
            [freeDays]="freeDays"
            [vehicleTypes]="vehicleTypes"
            [selectedTypeId]="selectedVehicleTypeId"
            [progressBarDesktop]="progressBarDesktop"
            [modalPayMethod1]="modalPayMethod1"
            (toggleSidebar)="toggleSidebar()"
            (sortChange)="onSortChange($event)"
            (typeChange)="onVehicleTypeChange($event)"
        ></fe-vehicle-list>

    </section>
</main>
<fe-footer></fe-footer>

<fe-pay-method-modal #modalPayMethod1></fe-pay-method-modal>